

import { FC } from "react";
import ProjectListPresentation from "../../presentation/project.list.presentation/project.list.presentation";

import { type ProjectListContainerProps } from '../../types/types'
const ProjectListContainer: FC<ProjectListContainerProps> = ({ projects }) => {
  return <ProjectListPresentation projects={projects} />
}

export default ProjectListContainer
